/* journe-chapter.js - v17 motion for the closing chapter.
   [data-jx-rise]   children rise in, staggered, once the group enters the screen (.is-in).
   [data-jx-in]     gets .is-in once on screen (for one-off moves styled in each section).
   [data-jx-par=n]  drifts n x its distance from the screen centre (parallax).
   [data-jx-band=n] its first child slides sideways n x the scroll distance (the band).
   Transform and opacity only, one rAF loop, parked while nothing moving is on screen.
   Reduced motion: everything is shown at rest. */
(function () {
  if (window.__jx) return;
  window.__jx = true;
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;

  function once(sel, cls, margin) {
    var els = document.querySelectorAll(sel);
    if (!els.length) return;
    if (calm || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add(cls); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add(cls); io.unobserve(e.target); } });
    }, { rootMargin: margin || '0px 0px -12% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Product pages: the sections under the buy box rise in the same way (their own markup, tagged here). */
  if (document.body.classList.contains('template-product')) {
    document.querySelectorAll('.sw > .container, .bc__grid, .rec__band, .jdgm-section__head').forEach(function (el) {
      if (!el.hasAttribute('data-jx-rise')) el.setAttribute('data-jx-rise', '');
    });
  }

  document.querySelectorAll('[data-jx-rise]').forEach(function (g) {
    Array.prototype.forEach.call(g.children, function (c, i) { c.style.setProperty('--i', i); });
  });
  root.classList.add('jx-js');
  once('[data-jx-rise]', 'is-in');
  once('[data-jx-in]', 'is-in', '0px 0px -18% 0px');
  if (calm || !('IntersectionObserver' in window)) return;

  var movers = Array.prototype.slice.call(document.querySelectorAll('[data-jx-par], [data-jx-band]'));
  if (!movers.length) return;
  var live = new Set(), queued = false;
  var vis = new IntersectionObserver(function (es) {
    es.forEach(function (e) { e.isIntersecting ? live.add(e.target) : live.delete(e.target); });
    tick();
  }, { rootMargin: '20% 0px' });
  movers.forEach(function (m) { vis.observe(m); });

  function paint() {
    queued = false;
    var vh = window.innerHeight;
    live.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (el.hasAttribute('data-jx-band')) {
        var k = parseFloat(el.getAttribute('data-jx-band')) || 0.3;
        var track = el.firstElementChild;
        var half = track.scrollWidth / 2 || 1;
        var x = ((vh - r.top) * k) % half;
        track.style.transform = 'translate3d(' + (-x).toFixed(1) + 'px,0,0)';
      } else {
        var s = parseFloat(el.getAttribute('data-jx-par')) || 0.1;
        var d = (r.top + r.height / 2) - vh / 2;
        el.style.transform = 'translate3d(0,' + (d * -s).toFixed(1) + 'px,0)';
      }
    });
  }
  function tick() { if (!queued && live.size) { queued = true; requestAnimationFrame(paint); } }
  window.addEventListener('scroll', tick, { passive: true });
  window.addEventListener('resize', tick, { passive: true });
})();
